import React from 'react'
import { Row, Col, Avatar } from 'antd';
import {
  UserOutlined,
  GithubOutlined,
  QqOutlined,
  WeiboOutlined,
  ZhihuOutlined,
  WechatOutlined,
  TwitterOutlined,
  MailOutlined
} from '@ant-design/icons';

const SidePersonComponent = function () {
  return (
    <Row gutter={18}>
      <Col span={24}>
        <div className="person-container">
          <div className="person-wrapper">
            <Avatar size={64} src="http://image-nuiii.test.upcdn.net/photo/IMG_20190905_181434.jpg!/fw/256" icon={<UserOutlined />} />
            <div className="person-info">
              GG
            </div>

            <div className="partner-apps">
              <GithubOutlined />
              <QqOutlined />
              <WeiboOutlined />
              <ZhihuOutlined />
              <WechatOutlined />
              <TwitterOutlined />
              <MailOutlined />
            </div>
          </div>
        </div>
      </Col>
    </Row>
  )
}
export default SidePersonComponent